// import { GraphQLClient } from "graphql-request";

// const endpoint = process.env.NEXT_PUBLIC_WP_GRAPHQL_ENDPOINT;
// const graphQLClient = new GraphQLClient(endpoint);

// const GET_ALL_POSTS = `
//   query GetAllPosts {
//     posts {
//       nodes {
//         id
//         title
//         slug
//         excerpt
//         featuredImage {
//           node {
//             sourceUrl
//           }
//         }
//       }
//     }
//   }
// `;

// export const fetchBlogPosts = async () => {
//   try {
//     const data = await graphQLClient.request(GET_ALL_POSTS);
//     return data.posts.nodes;
//   } catch (error) {
//     console.error("Error fetching posts:", error);
//     return [];
//   }
// };


const endpoint = process.env.NEXT_PUBLIC_WP_GRAPHQL_ENDPOINT;

const GET_ALL_POSTS = `
  query GetAllPosts {
    posts {
      nodes {
        id
        title
        slug
        excerpt
        featuredImage {
          node {
            sourceUrl
          }
        }
      }
    }
  }
`;

export const fetchBlogPosts = async () => {
  try {
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query: GET_ALL_POSTS }),
      next: { revalidate: 7200 }, // кэш на 2 часа
    });

    if (!res.ok) {
      throw new Error(`GraphQL request failed: ${res.statusText}`);
    }

    const data = await res.json();
    return data.data.posts.nodes;
  } catch (error) {
    console.error("Error fetching posts:", error);
    return [];
  }
};